import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { cn } from '../../lib/utils';
import { useAuthModal, useCart, useFavorites } from '../../providers';
import { AdminHeader } from './AdminHeader';
import { ProfileMenu } from './ProfileMenu';

const NAV = [
  { to: '/', label: 'ГОЛОВНА' },
  { to: '/catalog', label: 'КАТАЛОГ' },
];

export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const cart = useCart();
  const favorites = useFavorites();
  const favActive = favorites.count > 0 || location.pathname === '/favorites';
  const { data: user } = useAuth();
  const authModal = useAuthModal();

  if (user?.role === 'admin') return <AdminHeader />;

  return (
    <header className="sticky top-0 z-20 flex flex-wrap items-center gap-4 border-b border-line bg-bg/[0.92] px-6 py-[14px] backdrop-blur-[8px]">
      <button
        type="button"
        onClick={() => navigate('/')}
        className="flex items-center gap-2 border-none bg-transparent cursor-pointer p-0"
      >
        <span className="flex h-10 w-[52px] items-center justify-center bg-accent text-[20px] font-bold tracking-[-0.02em] text-bg">
          214°
        </span>
        <span className="flex flex-col items-start gap-[2px] leading-none">
          <span className="mono-label text-[12px]">Кава</span>
          <span className="mono-label text-[12px]">Свіжої обсмажки</span>
        </span>
      </button>

      <nav className="flex flex-1 justify-center gap-2">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cn('px-3 py-2 text-[13px] font-semibold', isActive ? 'text-ink' : 'text-muted-2')
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="flex items-center gap-1">
        <button
          type="button"
          title="Улюблене"
          onClick={() => navigate('/favorites')}
          className={cn(
            'flex items-center gap-[6px] border-none bg-transparent px-[10px] py-2 font-mono text-[12px] font-bold cursor-pointer',
            favActive ? 'text-accent' : 'text-muted',
          )}
        >
          <span className="text-[30px] leading-none">♥</span>
          {favorites.count}
        </button>

        {user ? (
          <ProfileMenu user={user}>
            <button
              type="button"
              title="Профіль"
              className="border-none bg-transparent px-[10px] py-2 text-accent cursor-pointer"
            >
              <svg
                width="19"
                height="19"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="8.5" r="3.6" />
                <path d="M4.8 20a7.2 7.2 0 0 1 14.4 0" />
              </svg>
            </button>
          </ProfileMenu>
        ) : (
          <button
            type="button"
            title="Профіль"
            onClick={() => authModal.open('login')}
            className="border-none bg-transparent px-[10px] py-2 text-muted cursor-pointer"
          >
            <svg
              width="19"
              height="19"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <circle cx="12" cy="8.5" r="3.6" />
              <path d="M4.8 20a7.2 7.2 0 0 1 14.4 0" />
            </svg>
          </button>
        )}

        <button
          type="button"
          title="Кошик"
          onClick={cart.open}
          className={cn(
            'btn-press flex items-center gap-2 border px-[14px] py-[9px] font-mono text-[12px] font-bold cursor-pointer',
            cart.count > 0
              ? 'bg-accent text-bg border-accent'
              : 'bg-transparent text-muted border-stroke',
          )}
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M5 8h14l-1.2 11.2H6.2z" />
            <path d="M8.5 8V6a3.5 3.5 0 0 1 7 0v2" />
          </svg>
          {cart.count}
        </button>
      </div>
    </header>
  );
}
